<script>
  import ApplicationState from "../../../Stores/applicationStates"
  import Navbar from "../../../Shared/Navbar/index.svelte"
  import Footer from "../../../Shared/footer.svelte"
  import Chart from "./Components/chart.svelte"
  import Table from "../../../Shared/Table/table.svelte"
  import Stats from "./Components/stats.svelte"
  import List from "./Components/list.svelte"
  import notify from "../../../Script/notify"
  import LoadingScreen from "../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import { onMount } from "svelte"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../Script/queryString"
  import DaysDropdown from "./Components/daysDropdown.svelte"
  import AnalyticsFilter from "./Components/analyticsFilter.svelte"
  import { getRequest } from "../../../Script/apiMethods"

  /**
   * @type {Boolean} - for loading screen Show or hide
   */
  let apiCallBtnDisable = false

  /**
   * @type {Object} - to store view, verify, download, publish count
   */
  let count

  /**
   * @type {Array} - to store Document list data
   */
  let list = []

  /**
   * @type {Number} - to show pagination number for table
   */
  let listCount
  /**
   * @type {Boolean} - to show viewed list
   */
  let viewed = true
  /**
   * @type {Boolean} - to show verified list
   */
  let verified = false
  /**
   * @type {Boolean} - to show download list
   */
  let download = false
  /**
   * @type {boolean} whether to show filter component or not
   */
  let showFilterForm = false
  /**
   * @type {boolean} whether to shoiw day dropdown or not
   */
  let daysModel = false

  /**
   * @type {Number} - how many list need to show
   */
  let limit

  /**
   * @type {Number} - which page list need to show
   */
  let page

  /**
   * @type {Number} - which order need to show (in order to date)
   */
  let sort

  /**
   * @type {Object} - object get from window location
   */
  let query

  /**
   * @type {Array} - it contains chart data
   */
  let chartData = []

  /**
   * @type {String} start date for stats
   */
  let startDate = ""

  /**
   * @type {String} end date for stats
   */
  let endDate = new Date(Date.now()).toISOString()

  /**
   * @type {Number} how many days we have to show data
   */
  let days = 7
  let docAnlytics

  /**
   * this funtion fetch all stat data while page loading
   */
  onMount(async () => {
    try {
      apiCallBtnDisable = true
      query = queryStringToJSON($querystring)
      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      viewed = query.state == "viewed" ? true : false
      verified = query.state == "verified" ? true : false
      download = query.state == "download" ? true : false

      if (query.state == undefined) viewed = true
      // startDate = query.sdate ? query.sdate : "2021-09-01T00:00:00Z"
      days = query.days ? query.days : 7
      let a = 24 * 60 * 60 * 1000 * days
      let b = new Date().getTime()

      startDate = query.sdate ? query.sdate : new Date(b - a).toISOString()
      endDate = query.edate ? query.edate : new Date(Date.now()).toISOString()
      if (query.sdate) days = "Custom"

      if ($ApplicationState.issuerID) await fetchAllDates()
      // typeWriter(docAnlytics, "Document Analytics", 0)
    } catch (error) {
      console.error(error)
      const info = "PAGE: Document Analytics\nEVENT: onMount"
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  })

  const fetchLogs = async () => {
    try {
      let type
      let state

      if (viewed) {
        type = "view"
        state = "viewed"
      } else if (verified) {
        type = "verify"
        state = "verified"
      } else if (download) {
        type = "download"
        state = "download"
      }

      const { data, count } = await getRequest(`/api/analytics/v2/${type}?issuer=${$ApplicationState.issuerID}&limit=${limit}&page=${page}&sort=${sort}&sdate=${startDate}&edate=${endDate}`)
      list = data
      listCount = count
      push(`/analytics/documents?limit=${limit}&page=${page}&sort=${sort}${!query.sdate ? `&days=${days}` : `&sdate=${startDate}&edate=${endDate}`}&state=${state}`)
    } catch (error) {
      throw error
    }
  }

  /**
   * @description This function called other all data fetching function
   */
  const fetchAllDates = async () => {
    try {
      // endDate = new Date(Date.now()).toISOString()
      const statData = await getRequest(`/api/analytics/v2/count?issuer=${$ApplicationState.issuerID}&sdate=${startDate}&edate=${endDate}`)
      count = statData

      const CONFIG = {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      }

      const publishCount = await getRequest(`/api/swagger/v2/documents/stat?sdate=${startDate}&edate=${endDate}`, CONFIG)
      count.publish = publishCount.count

      const fetchedChartData = await getRequest(`/api/analytics/v2/chart?issuer=${$ApplicationState.issuerID}&sdate=${new Date(startDate.slice(0, 10)).toISOString()}&edate=${new Date(endDate.slice(0, 10)).toISOString()}`)
      chartData = fetchedChartData.data

      await fetchLogs()
    } catch (error) {
      throw error
    }
  }

  /**
   * @description this functions runs when tables entiries are changed (Table Component).
   */
  const changeTableEntries = async (e) => {
    try {
      apiCallBtnDisable = true
      limit = e.detail.entries ? e.detail.entries : 10
      page = e.detail.activePage ? e.detail.activePage : 1
      sort = e.detail.sort ? e.detail.sort : -1
      await fetchLogs()
    } catch (error) {
      const info = "PAGE: Document Analytics\nEVENT: Error occurred during actions such as sorting by date, changing display entries, or navigating pages."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description Function to fetch templates based on user input (Filter Component).
   */
  const whileChangingEntries = async (e) => {
    try {
      page = 1
      days = "Custom"
      apiCallBtnDisable = true
      if (e.detail.startDate) query.sdate = startDate = e.detail.startDate
      if (e.detail.endDate) query.edate = endDate = e.detail.endDate
      await fetchAllDates()
    } catch (error) {
      const info = "PAGE: Document Analytics\nEVENT: Error occurred while changing date filter."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description Function to reset the user input(table Compo)
   */
  const resetList = async () => {
    try {
      apiCallBtnDisable = true
      limit = 10
      page = 1
      sort = -1
      days = 7
      let a = 24 * 60 * 60 * 1000 * days
      let b = new Date().getTime()
      startDate = new Date(b - a).toISOString()
      endDate = new Date(Date.now()).toISOString()
      query.sdate = ""
      query.edate = ""
      // startDate = "2021-09-07T00:00:00Z"
      // endDate = new Date(Date.now()).toISOString()
      await fetchAllDates()
    } catch (error) {
      const info = "PAGE: Document Analytics\nEVENT: Error occurred while resetting date filter."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  /**
   * @description while change the days (7,30,60,90) count this function will run for changing respective dates
   */
  const getDaysToDate = async () => {
    page = 1
    try {
      apiCallBtnDisable = true
      daysModel = false
      let a = 24 * 60 * 60 * 1000 * days
      let b = new Date().getTime()
      startDate = new Date(b - a).toISOString()
      endDate = new Date(Date.now()).toISOString()
      query.sdate = ""
      query.edate = ""
      await fetchAllDates()
    } catch (error) {
      const info = "PAGE: Document Analytics\nEVENT: Error occurred while changing days filter."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }
</script>

<svelte:head>
  <title>Document Analytics</title>
</svelte:head>
<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  {#if apiCallBtnDisable}
    <LoadingScreen msg={"Fetching Document Analytics"} />
  {/if}
  <div class="px-6">
    <div class="relative mx-auto mb-40 mt-10 h-auto w-full max-w-[920px] select-none">
      <div class="flex items-center justify-between">
        <div class="flex select-none flex-col gap-3 2xl:flex-row 2xl:items-center">
          <!-- svelte-ignore a11y-missing-content -->
          <!-- <h1 id="docAnlytics" bind:this={docAnlytics} class=" text-lg font-bold dark:text-white mobile:text-2xl" /> -->
          <h1 class=" text-lg font-bold dark:text-white mobile:text-2xl">Document Analytics</h1>
          <div class="hidden font-bold text-blue-500 md:block">
            {#if query && query.sdate}
              <!-- ({startDate.slice(0, 16)}) - ({endDate.slice(0, 16)}) -->
              <!-- {new Date(startDate).toUTCString().slice(0, 26)} - {new Date(endDate).toUTCString().slice(0, 26)} -->
              (After) {new Date(new Date(startDate).getTime() - new Date().getTimezoneOffset() * 60000).toUTCString().slice(0, 16)} - (Before) {new Date(new Date(endDate).getTime() - new Date().getTimezoneOffset() * 60000).toUTCString().slice(0, 16)}
            {:else}
              <div class="flex items-center gap-3">
                <span>
                  For last {days} days
                </span>
                <span data-tooltip="(After) {startDate} - (Before) {endDate}" tooltip-position="top">
                  <i class="fa-solid fa-circle-info" />
                </span>
              </div>
            {/if}
          </div>
        </div>
        <div class="relative flex w-3/5 items-center gap-3 mobile:w-fit">
          <DaysDropdown
            dropdownItems={[7, 30, 60, 90]}
            selected={days}
            on:onToggleDropDown={() => (showFilterForm = false)}
            on:onSelect={(e) => {
              days = e.detail
              getDaysToDate()
            }}
          />
          <AnalyticsFilter on:reset={resetList} on:entriesChanged={whileChangingEntries} />
        </div>
      </div>
      <div class="relative mt-3 min-h-[530px] select-none space-y-12 overflow-hidden rounded-md bg-white p-6 dark:bg-mdGray md:p-12">
        <Stats {count} />
        <Chart {chartData} />
        <div class="relative">
          <div class="absolute right-0 top-0 z-10 flex gap-1.5 mobile:gap-3">
            <button
              name="tooltip"
              id="Viewed"
              tooltip-position="top"
              on:click={async () => {
                if (!viewed) {
                  try {
                    apiCallBtnDisable = true
                    page = 1
                    viewed = true
                    verified = false
                    download = false
                    await fetchLogs()
                  } catch (error) {
                    const info = "PAGE: Document Analytics\nEVENT: While fetching viewed document access log"
                    notify.danger(error, info)
                  } finally {
                    apiCallBtnDisable = false
                  }
                }
              }}
              class="flex items-center rounded-md border {viewed ? 'border-sky-500 bg-sky-500 text-white' : 'border-[#a0a1a580]  bg-transparent text-gray-800 dark:text-gray-200 dark:hover:text-white '} px-2 py-1 hover:border-sky-600 hover:bg-sky-600 hover:text-white active:bg-sky-400 active:text-white sm:px-3"
            >
              <i class="fa-solid fa-eye" />
              <span class="hidden sm:block">&nbsp;&nbsp;Viewed</span>
            </button>
            <button
              name="tooltip"
              id="Verified"
              tooltip-position="top"
              on:click={async () => {
                if (!verified) {
                  try {
                    apiCallBtnDisable = true
                    page = 1
                    viewed = false
                    verified = true
                    download = false
                    await fetchLogs()
                  } catch (error) {
                    const info = "PAGE: Document Analytics\nEVENT: While fetching verified document access log"
                    notify.danger(error, info)
                  } finally {
                    apiCallBtnDisable = false
                  }
                }
              }}
              class="flex items-center rounded-md border {verified ? 'border-green-500 bg-green-500 text-white' : 'border-[#a0a1a580]  bg-transparent text-gray-800 dark:text-gray-200 dark:hover:text-white'}  px-2 py-1 hover:border-green-600 hover:bg-green-600 hover:text-white active:bg-green-400 active:text-white sm:px-3"
            >
              <i class="fa-solid fa-circle-check" />
              <span class="hidden sm:block">&nbsp;&nbsp;Verified</span>
            </button>
            <button
              name="tooltip"
              id="Downloaded"
              tooltip-position="top"
              on:click={async () => {
                if (!download) {
                  try {
                    apiCallBtnDisable = true
                    page = 1
                    viewed = false
                    verified = false
                    download = true
                    await fetchLogs()
                  } catch (error) {
                    const info = "PAGE: Document Analytics\nEVENT: While fetching downloaded document access log"
                    notify.danger(error, info)
                  } finally {
                    apiCallBtnDisable = false
                  }
                }
              }}
              class="flex items-center rounded-md border {download ? 'border-violet-500 bg-violet-500 text-white' : 'border-[#a0a1a580] bg-transparent text-gray-800 dark:text-gray-200 dark:hover:text-white'} px-2 py-1 hover:border-violet-600 hover:bg-violet-600 hover:text-white active:bg-violet-400 active:text-white sm:px-3"
            >
              <i class="fa-solid fa-circle-down" />
              <span class="hidden sm:block">&nbsp;&nbsp;Downloaded</span>
            </button>
          </div>
          <Table on:changeEntries={changeTableEntries} on:resetEntries={resetList} bind:activePage={page} title={"Document<br/>Access Log"} jsonData={list} count={listCount} search={false} nameSort={false}>
            {#if list.length}
              {#each list as json}
                <List {json} />
              {/each}
            {:else}
              <div class="text-secondary2 select-none rounded-md bg-[#f7f7f7] py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no document access log data</div>
            {/if}
          </Table>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</div>
